import React from "react";
import "./About_Content.css";

const About_Content = () => {
  return (
    <section className="About_Content">
      <div className="container">
        <div className="content_div">
          <p className="dark_text">
            Scroma Venture, founded in 2004, is a leading wholesaler,
            distributor, retailer, importer / exporter, and service provider specializing in diverse
            cash handling solutions.

          </p>

          <p className="dark_text">
            Scroma Venture, under the leadership of Mr. Bhavesh Shah, proudly launched Maharashtra’s first technodetection machine in 2001.
          </p>

          <p className="simple_text">
            Based in Baramati, the company supplies a variety of products,
            including bundle note counting machines and currency counting
            machines, to banks and businesses throughout India.
          </p>

          <p className="simple_text">
            {" "}
            The firm prides itself on offering high-quality products while
            fostering transparency and building strong customer relationships.
            Led by Mr. Sunil Palekar, Scroma Venture has achieved considerable
            growth and is known for its outstanding after-sales service and
            inventive solutions for combating counterfeit currency. It employs a
            workforce of 50 to 100 people.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About_Content;
